<template>
  <BaseModal
    :id="'delete-validations'"
    :title="`Validations`"
    :size="'lg'"
    :message="message"
    @close="close($event)"
  >
    <template v-slot:breadcrumb>
      <Breadcrumb :breadcrumb="breadcrumb" />
    </template>

    <template v-slot:content v-if="see_history">
      <div style="margin-top: 20px">
        <a href="#" @click="see_history = false">Go back</a>
      </div>
      <div
        style="margin-top: 15px"
        class="w-100 table-responsive defaultproject__table overflow-y--2 table-fix-head"
        :style="`max-height: 35rem`"
      >
        <table class="table animate__animated animate__fadeIn animate__fast">
          <thead style="background-color: #f1f1f1">
            <tr>
              <th
                style="font-weight: normal !important"
                class="header-item-manual"
                v-for="(item, i) in history_table_headers"
                :key="i"
                scope="col"
                v-html="item.name"
              />
            </tr>
          </thead>
          <tbody class="">
            <template>
              <tr v-for="(item, i) in validations_associate" :key="i">
                <td v-html="`${i + 1}`" />
                <td v-html="item.name" />
                <td v-html="item.module_name" />
                <td v-html="item.deleted_at" />
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </template>
    <template v-slot:content v-else>
        <form @submit.prevent="deactivateAssociates()">
            <div class="w-100 table-responsive defaultproject__table overflow-y--2 table-fix-head">
                <table class="table">
                <thead>
                    <tr style="background-color: #fff">
                    <td class="header-item-manual">
                        <span class="custom-control custom-checkbox">
                        <input
                            :id="`checkAllAssociates`"
                            type="checkbox"
                            class="custom-control-input"
                            v-model="select_all"
                            @change="selectAll()"
                        />
                        <label :for="`checkAllAssociates`" class="custom-control-label ml-2" />
                        </span>
                    </td>
                    <th
                        style="font-weight: normal !important"
                        class="header-item-manual"
                        v-for="(item, i) in summary_table_headers"
                        :key="i"
                        scope="col"
                        v-html="item.name"
                    />
                    </tr>
                </thead>
                <tbody>
                    <template>
                    <tr v-for="(item, i) in validate_data" :key="i">
                        <td class="header-item-manual">
                            <span class="custom-control custom-checkbox">
                            <input
                                :id="`checkAllAssociate${item.associate.id}`"
                                type="checkbox"
                                class="custom-control-input"
                                v-model="item.checked"
                            />
                            <label :for="`checkAllAssociate${item.associate.id}`" class="custom-control-label ml-2" />
                            </span>
                        </td>
                        <td v-html="`${i + 1}`" />
                        <td v-html="item.associate.first_name + ' ' + item.associate.last_name" />
                        <td>
                        <a href="#" @click="seeHistory(i)">See history</a>
                        </td>
                    </tr>
                    </template>
                </tbody>
                </table>
            </div>
        <CentralLiteButtons :save_text="'Deactivate associates'"/> 
        </form>
    </template>
  </BaseModal>
</template>

<script>
import Breadcrumb from "@/components/BreadcrumbComponent/Breadcrumb";
import CentralLiteButtons from    '@/components/CentralLiteButtons'
import BaseModal from "@/components/BaseModal";

export default {
  name: "DeleteValidationsModal",

  props: ["breadcrumb", "validate_data"],

  components: {
    BaseModal,
    Breadcrumb,
    CentralLiteButtons
  },

  data() {
    return {
      summary_table_headers: [
        {
          name: "#",
        },
        {
          name: "Associate",
        },
        {
          name: "Options",
        },
      ],
      history_table_headers: [
        {
          name: "#",
        },
        {
          name: "name",
        },
        {
          name: "module",
        },
        {
          name: "In the recycle bin",
        },
      ],
      see_history: false,
      validations_associate: null,
      message:
        `The following associates were not deleted because they have history in the application, check the associates that you want to deactivate and click the "Deactivate associates" button `,
      select_all: true,
    };
  },

  methods: {
    close(event) 
    {
      this.$emit("close", event);
    },

    seeHistory(index) 
    {
      this.validations_associate = this.validate_data[index].validations;
      this.see_history = true;
    },

    selectAll()
    {
        this.validate_data.map(item => item.checked = this.select_all)
    },

    async deactivateAssociates()
    {
        let selected_items = this.validate_data.filter(item => item.checked)
        selected_items = selected_items.map(item => item.associate.id)

        let http_object = {
            ids: selected_items
        }

        const response = await this.postingByPost('deactivate_associates', http_object, 'delete-validations', false)

        if(response.status)
        {
            if(response.data?.associates)
            {
                
                this.$emit('replacingAssociates', response.data.associates)
            }
        }
    }
  },

  computed: {},

  mounted() {
  },
};
</script>
